module.exports = __webpack_public_path__ + "h5/img/nodata.9ac1823d.png";